// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getFirestore,
  connectFirestoreEmulator,
  clearIndexedDbPersistence,
} from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";

import { getAuth, connectAuthEmulator } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDobgljbMX87BFsyzbpn4XnqGvsuP81K5Q",
  authDomain: "eye-academy-b95b3.firebaseapp.com",
  projectId: "eye-academy-b95b3",
  storageBucket: "eye-academy-b95b3.appspot.com",
  messagingSenderId: "424934884434",
  appId: "1:424934884434:web:876712aaf2de398fae8b8b",
  measurementId: "G-VX1F5X5XTK",
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
export const firestore = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);
export const storage = getStorage(firebaseApp);
export const functions = getFunctions(firebaseApp, "europe-west2");
export const analytics = getAnalytics(firebaseApp);

// const db = firestore;

// const CACHE_CLEARED_KEY = "firestoreCacheCleared";

// async function clearFirestoreCacheOnce() {
//   const cacheCleared = localStorage.getItem(CACHE_CLEARED_KEY);

//   if (!cacheCleared) {
//     try {
//       await clearIndexedDbPersistence(db);
//       console.log("Firestore cache cleared successfully!");

//       // Mark the cache as cleared in localStorage
//       localStorage.setItem(CACHE_CLEARED_KEY, "true");

//       // Optional: Reload the page to ensure fresh data
//       window.location.reload(true);
//     } catch (err) {
//       console.error("Failed to clear Firestore cache:", err);
//     }
//   } else {
//     console.log("Firestore cache was already cleared for this user.");
//   }
// }

// // Call the function on app initialization
// clearFirestoreCacheOnce();
